import React, { Component, Fragment } from "react";
import { adminLabels } from '../../redux/constant/admin-label-constant';
import fileLogo from "assets/img/File-icon.svg";
import FileViewer from 'react-file-viewer';
import { CustomErrorComponent } from 'custom-error';
import { helperFunctions as HF } from 'helper/helperFunctions';
import ReactPlayer from 'react-player';
// import pdfIcon from "assets/img/pdf.svg";
// import tiffIcon from "assets/img/tiff.svg";
import videoIcon from "assets/img/video-player.svg";
const previewStyle = {
	display: 'inline-block',
	width: 100,
	height: 100,
};

class ImagePreview extends Component {
	constructor(props) {
		super(props);
	}

    previewFile = (src, name, index = null, ext = null, type) => {
    	console.log('type', type);
    	return(
			<div key={index} className="prevImgContainer">

				{
					type.includes('video')
					?
						type.includes('quicktime') 
						?
							<img className="uploaderIcon" src={videoIcon} />
						:
							<ReactPlayer url={src} controls={true} />
					:
						<FileViewer
					        fileType={ext}
					        filePath={src}
					        errorComponent={CustomErrorComponent}
					        onError={this.onError}
				        />

				}
				<div className="uploaderFileName">
					{ name }
				</div>
				{
					(this.props.removeFile && index !== null && !this.props.loading) &&
					<div className="prevRemove">
						<span onClick={()=>this.props.removeFile(this.props.type?this.props.type:null, index)}>
							&times;
						</span>
					</div>
					
				}
			</div>
    	);
    }
    onError(e) {
    console.log(e, 'error in file-viewer');
  }
	render(){
	    const {  filesToPreview } = this.props;
		return(
			<div className="content">
				{
					filesToPreview ?
					Array.isArray(filesToPreview) ?
					<div className="uploadImages flexElem flexThreeCols flexResponsive">
			            {
			            	filesToPreview.map((file, index) => (
			            			file.name ?
				            			this.previewFile(file.file, file.name, index, HF.returnExtFromImage( file.name), file.type )
							        :null
				            	)
			            	)
			            }
		          	</div> :
		          	<Fragment>
		          		{
		          			filesToPreview.name ?
		          				this.previewFile(filesToPreview.file, filesToPreview.name, 0, HF.returnExtFromImage( filesToPreview.name), filesToPreview.type )
				            :null
		          		}
		          	</Fragment>
		        	:null
		        }
			</div>
		);
	};
}

export default ImagePreview;



// WEBPACK FOOTER //
// ./src/components/Upload/ImagePreview.jsx